export default __webpack_public_path__ + "static/seranpark-232d8cb697ba3ad45319c42ac0c8601c.jpeg";